import React, { useState, useRef, useEffect } from 'react';
import '../styles/certifications.css';

const certifications = [
  { name: "Oracle Cloud 2025 Certified DevOps Professional", logo: "/assets/Devops.png" },
  { name: "Harness Certified Continuous Delivery & GitOps Developer", logo: "/assets/Hari.png"},
  { name: "Oracle Cloud Infrastructure 2025 Certified Developer Professional", logo: "/assets/Deve.png" },
  { name: "Aviatrix Certified Engineer (ACE) Multicloud Network Associate", logo: "/assets/MultiCloudNetwork.newlogo20260102-32-o6zlsg_page-0001.jpg" },
  { name: "Infosys Certified Java Foundation", logo: "/assets/c1.jpg" },
  { name: "Machine Learning (freeCodeCamp)", logo: "/assets/c4.jpg" },
  { name: "Research Publication (IRJTAE)", logo: "/assets/c10.jpg" },
  { name: "SBI Life HackAIthon", logo: "/assets/c11.png" },
  { name: "Sparkathon By Walmart", logo: "/assets/c12.jpg" },
  { name: "Naukri Campus AINCAT 2025", logo: "/assets/c9.jpg" },
  { name: "CodeQuezt Contest Coding Challenge", logo: "/assets/c8.jpg" },
  { name: "TATA Crucible Campus Quiz 2024", logo: "/assets/c7.jpg" },
  { name: "DEBUGIT (IIT BHU)", logo: "/assets/c3.jpg" },
  { name: "TATA Imagination Challenge", logo: "/assets/c13.jpg" },
  { name: "German - I (IIT Madras)", logo: "/assets/c6.jpg" },
  { name: "NPTEL Soft Skills", logo: "/assets/c14.jpg" },
  { name: "AWS Solutions Architecture Job Simulation", logo: "/assets/c2.jpg" },
];

const repeatedCerts = [...certifications, ...certifications];

export default function Certifications() {
  const [selectedCert, setSelectedCert] = useState(null);
  const trackRef = useRef(null);
  const containerRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    let animationPaused = false;

    const handleScroll = () => {
      if (!animationPaused) {
        setIsPaused(true);
        animationPaused = true;
        clearTimeout(container.pauseTimeout);
        container.pauseTimeout = setTimeout(() => {
          setIsPaused(false);
          animationPaused = false;
        }, 4000);
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="certifications" className="certifications-section">
      <h2 className="section-title">My <span>Certifications</span></h2>

      <div
        className="certifications-grid"
        ref={containerRef}
      >
        <div
          className={`certification-track ${isPaused ? 'paused' : ''}`}
          ref={trackRef}
        >
          {repeatedCerts.map((cert, index) => (
            <div
              className="certification-card"
              key={index}
              onClick={() => setSelectedCert(cert)}
            >
              <img src={cert.logo} alt={cert.name} className="cert-logo" />
              <h3 className="cert-name">{cert.name}</h3>
            </div>
          ))}
        </div>
      </div>

      {selectedCert && (
        <div className="cert-modal" onClick={() => setSelectedCert(null)}>
          <div className="modal-content">
            <span className="close-btn" onClick={() => setSelectedCert(null)}>&times;</span>
            <img src={selectedCert.logo} alt={selectedCert.name} />
          </div>
        </div>
      )}
    </section>
  );
}